/**
 * `checkbox` — measured: monday words the two rows as **`is not checked`** and
 * **`is checked`**, in that order, and offers nothing else. They are `is_empty` /
 * `is_not_empty` on the wire, because an unchecked checkbox stores no cell value.
 */
import { condition } from '../filter-conditions.js';
export const checkboxFilterConditions = [
    condition('is not checked', 'is_empty', 'none'),
    condition('is checked', 'is_not_empty', 'none'),
];
//# sourceMappingURL=filters.js.map